import {
    Datagrid,
    DateField,
    List,
    SelectInput,
    TextField,
    TopToolbar,
    TextInput,
} from 'react-admin';

const filters = [
    <SelectInput
        key="action"
        source="action"
        choices={[
            { id: 'invite', name: 'invite' },
            { id: 'resend_invite', name: 'resend_invite' },
            { id: 'revoke_invite', name: 'revoke_invite' },
            { id: 'update_user', name: 'update_user' },
            { id: 'delete_user', name: 'delete_user' },
            { id: 'accept_invite', name: 'accept_invite' },
            { id: 'cleanup_expired_invite', name: 'cleanup_expired_invite' },
            { id: 'add_gated_account', name: 'add_gated_account' },
            // Pre-rename rows (written before 2026-07-20) keep the old
            // action string — they are never migrated.
            { id: 'add_account', name: 'add_account (legacy)' },
            { id: 'set_gate_operators', name: 'set_gate_operators' },
            { id: 'create_api_key', name: 'create_api_key' },
            { id: 'revoke_api_key', name: 'revoke_api_key' },
        ]}
        alwaysOn
    />,
    <TextInput key="actor_uid" source="actor_uid" alwaysOn />,
];

const Actions = () => <TopToolbar />;

export const AuditList = () => (
    <List
        resource="admin_audit"
        filters={filters}
        actions={<Actions />}
        sort={{ field: 'created_at', order: 'DESC' }}
        title="Audit Log"
    >
        <Datagrid rowClick={false} bulkActionButtons={false}>
            <DateField source="created_at" showTime />
            <TextField source="action" />
            <TextField source="actor_email" />
            <TextField source="target_email" label="Target email/value" />
        </Datagrid>
    </List>
);
